import {Component} from '@angular/core';

@Component({
  selector: 'app-circle-client-icon',
  templateUrl: './circle-client-icon.component.html'
})
export class CircleClientIconComponent {
}
